import http from '@/utils/http';

import type { IRobloxTopChartsFetchParams } from '../pages/RobloxTopCharts/utils/buildRobloxTopChartsFetchParams';
import type { IRobloxTopChartsRow } from '../pages/RobloxTopCharts/types';

export const fetchRobloxTopChartsMetrics = (
  data: IRobloxTopChartsFetchParams,
  options?: { signal?: AbortSignal },
): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/game/roblox/topcharts/metrics',
    method: 'post',
    data,
    rawData: true,
    signal: options?.signal,
  }) as Promise<any>;
};

const mergeRobloxTopChartsRow = (
  item: Record<string, any>,
  entityInfoMap: Record<string, Record<string, any>>,
): IRobloxTopChartsRow => {
  const gameId = item?.game_id;
  const entityInfo = gameId ? entityInfoMap[gameId] : undefined;

  return {
    ...item,
    ...(entityInfo || {}),
    entity_info: entityInfo,
  };
};

export const parseRobloxTopChartsResponse = (
  response: any,
): { list: IRobloxTopChartsRow[]; total: number } => {
  const payload = response?.data ?? response ?? {};
  const entityInfoMap = response?.ext?.entity_info ?? {};
  const rawList = Array.isArray(payload?.list) ? payload.list : [];

  return {
    list: rawList.map((item: Record<string, any>) =>
      mergeRobloxTopChartsRow(item, entityInfoMap),
    ),
    total: Number(payload?.total) || 0,
  };
};
